import React, { ButtonHTMLAttributes } from 'react';

import styled from 'styled-components';

interface FanceButtonProps {
  $size: number;
  $gap?: number | 'auto';
  $iconSize?: number;
  $fontSize?: number;
  $isFull?: boolean;
  $isSelected?: boolean;
  $hasRadius?: boolean;
  $hasBgColor?: boolean;
}

const FancyButton = styled.button<FanceButtonProps>`
  ${({ $size, $gap, $fontSize, $isFull, $isSelected, $hasBgColor, $hasRadius, theme }) => ({
    width: $isFull ? '100%' : `${$size}px`,
    height: `${$size}px`,
    minWidth: $isFull ? '100%' : `${$size}px`,
    minHeight: `${$size}px`,
    fontSize: $fontSize ? `${$fontSize}px` : 'inherit',
    color: $isSelected ? theme.global.whiteTextColor : theme.global.textColor,
    backgroundColor: $isSelected
      ? theme.global.mainColor
      : $hasBgColor
      ? theme.ui.button.iconButtonBgColor
      : 'transparent',
    gap: $gap === 'auto' ? 0 : `${$gap}px`,
    justifyContent: $isFull ? ($gap === 'auto' ? 'space-between' : 'flex-start') : 'center',
    borderRadius: $hasRadius ? '8px' : 0,
    padding: $isFull ? '0px 16px' : 0,
    fontWeight: $isSelected ? 500 : 'inherit',
  })}

  display: flex;
  align-items: center;

  svg {
    font-size: ${(props) => `${props.$iconSize}px`};
  }

  &:hover {
    ${(props) => {
      if (!props.$isSelected) {
        return {
          backgroundColor: props.theme.ui.button.iconButtonHoverBgColor,
        };
      }
    }}
  }
`;

interface IconButtonProps extends FanceButtonProps, ButtonHTMLAttributes<HTMLButtonElement> {
  $hasBgColor?: boolean;
}

const IconButton = React.forwardRef(
  (
    {
      $size,
      $gap = 12,
      $iconSize = 20,
      $fontSize,
      $isFull = false,
      $isSelected = false,
      $hasRadius = false,
      $hasBgColor = false,
      children,
      ...rest
    }: IconButtonProps,
    ref: React.ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <FancyButton
        ref={ref}
        $size={$size}
        $gap={$gap}
        $iconSize={$iconSize}
        $fontSize={$fontSize}
        $isFull={$isFull}
        $isSelected={$isSelected}
        $hasRadius={$hasRadius}
        $hasBgColor={$hasBgColor}
        {...rest}
      >
        {children}
      </FancyButton>
    );
  }
);

export default IconButton;
